import { createSlice } from "@reduxjs/toolkit";
import { isFSA } from "apis/helpers/typeGuards";
// type predicate to help identify payloads with the signup state.
function isSignupStateResponse(action) {
    if (!isFSA(action)) {
        return false;
    }
    try {
        const payload = action.payload;
        // if the payload has 'state', we consider it a SignupStatusResponse
        return Boolean(payload.state !== undefined);
    }
    catch (_a) {
        return false;
    }
}
// type predicate for rtk queries that wrap the SignupStatusResponse
function hasSignupStateResponse(action) {
    if (!isFSA(action)) {
        return false;
    }
    return isSignupStateResponse(action.payload);
}
// export for use in tests
export const initialState = {};
export const signupSlice = createSlice({
    name: "signup",
    initialState,
    reducers: {
        setEmail: (state, action) => {
            state.email = action.payload.email;
            state.given_name = action.payload.given_name;
            state.surname = action.payload.surname;
        },
        setEmailCode: (state, action) => {
            state.email_code = action.payload;
        },
        setCaptchaResponse: (state, action) => {
            state.captcha = action.payload;
        },
        setNextPage: (state, action) => {
            state.next_page = action.payload;
        },
        setIdentityCollision(state, action) {
            state.identity_collision = action.payload;
        },
        resetState: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addMatcher(hasSignupStateResponse, (state, action) => {
            state.state = action.payload.payload.state;
        });
    },
});
